import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSupportData } from './useHawksearchAutocomplete';
import { parseSupportData } from './util';
import { SupportAPI } from '../core/src/support-client';
import { Helpers } from '../core/src/helpers';
import useSearchEndpoint from './useSearchEndpoint';
import { fetchSupportResultsUsingUrl, getInitialSupportSearchObjFromQueryString } from './util';
const NUM_RESULTS_PER_PAGE = 24;

const fetchResults = Helpers.memoize((supportApi, searchKey) => supportApi.typeahead( searchKey, NUM_RESULTS_PER_PAGE ), (supportApi, searchKey) => `${!!supportApi}${searchKey}`);

export const useSupportResults = () => {
    return useSelector(state => {
        try{
            return state.slugInfo.components.supportResults;
        }catch(e){}
    })
}

export default (searchKey, type) => {
    const [support, setSupport] = useState({});
    const [qsSearchKey, setQsSearchKey] = useState(null);
    const endpoints = useSearchEndpoint('support');
    const supportApi = endpoints && endpoints[0];
    // const supportResults = useSupportResults();
    // const dispatch = useDispatch();
    const qs = useSelector(state => state && state.router && state.router.location && state.router.location.search);

    const resetSearch = useCallback((fetchError) => {
        setSupport({ fetchError }) 
    }, [])

    useEffect(() => {
        if(type==='support'){
            try{
                const queryObj = getInitialSupportSearchObjFromQueryString();
                const searchKey = (queryObj && queryObj.q) || '';
                setQsSearchKey(searchKey);
            } catch(e) {}
        }
    }, [qs, type])

    const fetchSupport = useCallback(searchKey => {
        return fetchResults(supportApi, searchKey).then(data => {
            const supportPages = parseSupportData(data)
            setSupport({
                supportPages,
                searchKey,
            })
        }).catch( e => {
            resetSearch(e);
        });
    }, [!!supportApi])


    useEffect(() => {
        if(supportApi && type === 'support' && typeof qsSearchKey === 'string' && (!support || !support.searchKey || support.searchKey !== qsSearchKey)){
            // dispatch(fetchSupportResultsUsingUrl());
            fetchSupport(qsSearchKey);
        }
    }, [qsSearchKey, type, !!supportApi]);

    return support
}